import { queryStringParamsCache } from '../../app-kit/helpers/getCacheQueryStringParamsFromUrl';
import { getDefaultSortOption } from '../getDefaultSortOption';
import { getValidSortOptionByPropertyStatus } from '../getValidSortOptionByPropertyStatus';
import { getPropertyStatusFromUrl } from './queryStringHelpers';

export const getSortOptionFromUrl = (url: string): string => {
  const propertyStatus = getPropertyStatusFromUrl(url);
  const { sortOption, polygons, flow } = queryStringParamsCache.extractQueryAsParamsFromUrl(url);

  const isGeoShapeBasedSearch = Boolean(polygons) || flow === 'commute';

  const { defaultValue } = getDefaultSortOption({
    isGeoShapeBasedSearch,
    propertyStatus,
  });

  return getValidSortOptionByPropertyStatus({
    propertyStatus,
    sortOption: sortOption ?? defaultValue,
    isGeoShapeBasedSearch,
  });
};
